import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  GeneratedContentImproveWritingInput,
  GeneratedContentImproveWritingPayload
} from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentImproveWritingInput;
type TData = GeneratedContentImproveWritingPayload;

export const useContentGenerationImprove = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentImproveWriting($input: GeneratedContentImproveWritingInput!) {
      generatedContentImproveWriting(input: $input) {
        success
        errors
        errorCode
        text
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
